import { useLocation, useNavigate } from 'react-router-dom';
import { ChartBar, CurrencyDollar, Envelope, ListNumbers, SignOut, Users, WarningCircle } from '@phosphor-icons/react';
import { useState } from 'react';
import { ConfirmDialog } from '@/components/admin/ConfirmDialog';

const monoFont = "'IBM Plex Mono', monospace";

const tabs = [
  { path: '/admin', label: 'Dashboard', icon: ChartBar, exact: true },
  { path: '/admin/usuarios', label: 'Usuários', icon: Users },
  { path: '/admin/convites', label: 'Convites', icon: Envelope },
  { path: '/admin/espera', label: 'Lista de espera', icon: ListNumbers },
  { path: '/admin/financeiro', label: 'Financeiro', icon: CurrencyDollar },
  { path: '/admin/emails', label: 'E-mails', icon: WarningCircle },
];

export function SASidebar({ onSignOut }: { onSignOut: () => void }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [showSignOut, setShowSignOut] = useState(false);

  const isActive = (path: string, exact?: boolean) => {
    if (exact) return location.pathname === path;
    return location.pathname.startsWith(path);
  };

  return (
    <aside style={{
      position: 'fixed', top: 0, left: 0, width: 220, height: '100vh',
      backgroundColor: '#0A0A0A', borderRight: '0.5px solid rgba(247,246,242,0.12)',
      display: 'flex', flexDirection: 'column',
    }}>
      <div style={{ padding: '24px 20px 16px', borderBottom: '0.5px solid rgba(247,246,242,0.12)' }}>
        <span style={{ fontFamily: monoFont, fontSize: 12, fontWeight: 300, color: 'rgba(247,246,242,0.35)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
          CRIAAA — ADMIN
        </span>
      </div>

      <div style={{ flex: 1, padding: '12px 0' }}>
        {tabs.map((tab, i) => {
          const active = isActive(tab.path, tab.exact);
          return (
            <button
              key={tab.path}
              onClick={() => navigate(tab.path)}
              style={{
                fontFamily: monoFont, fontSize: 13, fontWeight: 300,
                padding: '10px 20px', width: '100%', textAlign: 'left',
                display: 'flex', alignItems: 'center', gap: 10,
                background: active ? 'rgba(247,246,242,0.06)' : 'none',
                border: 'none', cursor: 'pointer',
                color: active ? '#F7F6F2' : 'rgba(247,246,242,0.45)',
                transition: 'all 0.15s ease',
              }}
              onMouseEnter={e => { if (!active) { e.currentTarget.style.backgroundColor = 'rgba(247,246,242,0.03)'; e.currentTarget.style.color = 'rgba(247,246,242,0.7)'; } }}
              onMouseLeave={e => { if (!active) { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = 'rgba(247,246,242,0.45)'; } }}
            >
              <tab.icon size={16} weight="thin" />
              {tab.label}
            </button>
          );
        })}
      </div>

      <div style={{ borderTop: '0.5px solid rgba(247,246,242,0.12)', padding: '16px 20px' }}>
        <button
          onClick={() => setShowSignOut(true)}
          style={{
            fontFamily: monoFont, fontSize: 13, fontWeight: 300,
            color: 'rgba(247,246,242,0.3)', background: 'none', border: 'none',
            cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8, padding: 0,
            transition: 'color 0.15s ease',
          }}
          onMouseEnter={e => e.currentTarget.style.color = 'rgba(247,246,242,0.7)'}
          onMouseLeave={e => e.currentTarget.style.color = 'rgba(247,246,242,0.3)'}
        >
          <SignOut size={14} weight="thin" />
          Sair
        </button>
        <ConfirmDialog
          open={showSignOut}
          onOpenChange={setShowSignOut}
          title="Sair do Admin"
          description="Tem certeza que deseja sair?"
          confirmLabel="Sair"
          cancelLabel="Cancelar"
          onConfirm={onSignOut}
          destructive
        />
      </div>
    </aside>
  );
}
